import apiSportEvents from '@/api/sports-events'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getSportEventsListStart: '[sport events list admin] Get sport events start',
  getSportEventsListSuccess:
    '[sport events list admin] Get sport events success',
  getSportEventsListFailure:
    '[sport events list admin] Get sport events failure',
}

export const actionTypes = {
  getSportEventsList: '[sport events list admin] Get sport events',
}

const mutations = {
  [mutationTypes.getSportEventsListStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getSportEventsListSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getSportEventsListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getSportEventsList](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)
    context.commit(mutationTypes.getSportEventsListStart)
    return new Promise((resolve) => {
      apiSportEvents
        .getSportEventsListAdmin(params)
        .then((response) => {
          context.commit(mutationTypes.getSportEventsListSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getSportEventsListFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
